import { IPagination } from "@evennt-tech/api-v2-core";

const getNextPageParam = ({
  meta: { currentPage, totalPages },
}: IPagination<unknown>): number | undefined =>
  totalPages && currentPage < totalPages ? currentPage + 1 : undefined;

export default getNextPageParam;
